import { XeroContactsGetResponseType } from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useXeroContactsCSV = <TData = XeroContactsGetResponseType,>() => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationKey: [user?.uid, business?.id, ServerStateKeys.XeroContacts],
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        responseType: "text",
        path: `xero/contacts`,
      }).then((data) => data.data as TData),
  });
};
